// extracted by mini-css-extract-plugin
export default {"filter":"DrinksInGroup_filter__ZR0Yu"};